import { accountsRoyaltyActions } from "./accounts/actions";
import { contractsRoyaltyActions } from "./contracts/actions";
import { dealsRoyaltyActions } from "./deals/actions";
import { RoyaltyModulePluginStore } from "./plugin-store";
import { recoupableActions } from "./recoupable/actions";
import {  statementActions } from "./statement/actions";

export const actions = {
  ...accountsRoyaltyActions,
  ...contractsRoyaltyActions,
  ...dealsRoyaltyActions,
  ...statementActions,
  ...recoupableActions,
  ...RoyaltyModulePluginStore.actions,
};
